import axios from "axios";
import { API_BASE_URL } from "./apiUrl";
import { API_URL } from "./apiUrl";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import { logger } from "../../utils/logger";

// GET request
// export const fetchData = async (endpoint) => {
//   try {
//     let token = localStorage.getItem('user_token')

//     const response = await fetch(`${API_URL}/${endpoint}`, {
//       method: 'GET',
//       headers: {
//         'Content-Type': 'application/json',
//         'Authorization': `Bearer ${token}`
//       },
//     });

//     if (!response.ok) {
//       const errorDetails = await response.json();
//       const errorMessages = Object.values(errorDetails).flat();
//       throw new Error(errorMessages[0]);
//     }
//     return await response.json();
//   } catch (error) {
//     throw error;
//   }
// };


// export const fetchDataAuth = async (endpoint) => {
//   try {
//     let token = localStorage.getItem('user_token')

//     const response = await fetch(`${API_BASE_URL}/${endpoint}`, {
//       method: 'GET',
//       headers: {
//         'Content-Type': 'application/json',
//         'Authorization': `Bearer ${token}`
//       },
//     });

//     if (!response.ok) {
//       const errorDetails = await response.json();
//       const errorMessages = Object.values(errorDetails).flat();
//       throw new Error(errorMessages[0]);
//     }
//     return await response;
//   } catch (error) {
//     throw error;
//   }
// };

// export const fetchToken = async (identity, roomName) => {
//   try {
//     const response = await fetch(`http://localhost:8081/api/auth/generateToken?identity=${identity}&roomName=${roomName}`, {
//       method: 'GET',
//       headers: {
//         'Content-Type': 'application/json',
//         // 'Authorization': `Bearer ${token}`
//       },
//     });


//     if (!response.ok) {
//       const errorDetails = await response.json();
//       const errorMessages = Object.values(errorDetails).flat();
//       throw new Error(errorMessages[0]);
//     }
//     const data = response.json();
//     return await data;
//   } catch (error) {
//     throw error;
//   }
// };


// POST request with token
// export const postData = async (endpoint, body) => {
//   let token = localStorage.getItem('user_token')
//   try {
//     const response = await fetch(`${API_BASE_URL}/${endpoint}`, {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//         'Authorization': `Bearer ${token}`
//       },
//       body: JSON.stringify(body),
//     });
//     if (!response.ok) {
//       const errorDetails = await response.json();
//       const errorMessages = Object.values(errorDetails).flat();
//       throw new Error(errorMessages[0]);
//     }
//     return await response;
//   } catch (error) {
//     throw error;
//   }
// };

// POST request with token
// export const updateData = async (endpoint, body) => {
//   let token = localStorage.getItem('user_token')
//   try {
//     const response = await fetch(`${API_BASE_URL}/${endpoint}`, {
//       method: 'PATCH',
//       headers: {
//         'Authorization': `Bearer ${token}`
//       },
//       body: body,
//     });
//     if (!response.ok) {
//       const errorDetails = await response.json();
//       const errorMessages = Object.values(errorDetails).flat();
//       throw new Error(errorMessages[0]);
//     }
//     return await response;
//   } catch (error) {
//     throw error;
//   }
// };

// export const putData = async (endpoint, body) => {
//   let token = localStorage.getItem('user_token')
//   try {
//     const response = await fetch(`${API_BASE_URL}/${endpoint}`, {
//       method: 'PUT',
//       headers: {
//         'Content-Type': 'application/json',
//         'Authorization': `Bearer ${token}`
//       },
//       body: body,
//     });
//     if (!response.ok) {
//       const errorDetails = await response.json();
//       const errorMessages = Object.values(errorDetails).flat();
//       throw new Error(errorMessages[0]);
//     }
//     return await response;
//   } catch (error) {
//     throw error;
//   }
// };

// export const deleteData = async (endpoint) => {
//   let token = localStorage.getItem('user_token')
//   try {
//     const response = await fetch(`${API_BASE_URL}/${endpoint}`, {
//       method: 'DELETE',
//       headers: {
//         'Authorization': `Bearer ${token}`
//       }
//     });
//     if (!response.ok) {
//       const errorDetails = await response.json();
//       const errorMessages = Object.values(errorDetails).flat();
//       throw new Error(errorMessages[0]);
//     }
//     return await response;
//   } catch (error) {
//     throw error;
//   }
// };

// POST request without token
// export const postRequest = async (endpoint, body) => {
//   try {
//     const response = await fetch(`${API_BASE_URL}/${endpoint}`, {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//       },
//       body: JSON.stringify(body),
//     });
//     if (!response.ok) {
//       const errorDetails = await response.json();
//       const errorMessages = Object.values(errorDetails).flat();
//       throw new Error(errorMessages[0]);
//     }
//     return await response;
//   } catch (error) {
//     throw error;
//   }
// };

// export const fetchDataAxiosPost = async (endpoint, body) => {
//   try {
//     const api = axios.create({
//       baseURL: API_BASE_URL,
//       headers: {
//         "Content-Type": "application/json"
//       },
//       withCredentials: true 
//     });
//     const response = await api.post(`${endpoint}`, body);
//     return await response;
//   } catch (error) {
//     return "Bad Request"
//   }
// };

// export const fetchDataAxiosPost = async (endpoint, body, config = {}) => {
//   try {
//     const response = await api.post(endpoint, body, config);
//     return response;
//   } catch (error) {
//     return error?.response;
//   }
// };

export const fetchDataAxiosPost = async (endpoint, body, config = {}) => {
  const response = await api.post(endpoint, body, config);
  return response;
};

// Rejects the request the moment `signal` aborts, so a cancelled load stops
// occupying one of the browser's per-host connections instead of running to
// completion in the background.
export const withAbortSignal = (signal, config = {}) =>
  signal ? { ...config, signal } : config;

export const getAuthContext = () => {
  const storedEmail = localStorage.getItem("userEmail")?.trim() || "";
  const storedRole = localStorage.getItem("userRole")?.trim() || "";
  const token = localStorage.getItem("access_token");

  let email = storedEmail;
  let role = storedRole;

  if ((!email || !role) && token) {
    try {
      const decodedToken = jwtDecode(token);
      email = email || decodedToken?.email || decodedToken?.sub || "";
      role = role || decodedToken?.role || "";

      if (!storedEmail && email) {
        localStorage.setItem("userEmail", email);
      }
      if (!storedRole && role) {
        localStorage.setItem("userRole", role);
      }
    } catch (error) {
      logger.error("Error decoding token for auth context:", error)
    }
  }

  return { email, role };
};


export const editDataAxiosPut = async (endpoint, body, config = {}) => {
  const response = await api.put(endpoint, body, config);
  return response;
};


export const updateData = async (endpoint, body) => {
  try {
    // const api = axios.create({
    //   baseURL: API_BASE_URL,
    //   headers: {
    //     "Content-Type": "application/json"
    //   },
    //   withCredentials: true 
    // });
    const response = await api.put(`${endpoint}`, body);
    return await response;
  } catch (error) {
    logger.error('Error fetching data:', error)
    throw error;
  }
};

// Accepts config as a 3rd argument
export const editMultipartData = async (endpoint, body, config = {}) => {
  try {
    const response = await uploadFileApi.put(`${endpoint}`, body, {
      withCredentials: true,
      ...config,
    });
    return response;
  } catch (error) {
    logger.error('Error updating data:', error)
    throw error;
  }
};


export const deleteData = async (endpoint, config = {}) => {
  try {
    const response = await api.delete(`${endpoint}`, config);
    return await response;
  } catch (error) {
    logger.error('Error fetching data:', error)
    throw error;
  }
};

// True when a request was cancelled because the caller navigated away or
// started a newer load. Callers should swallow these instead of surfacing an
// error toast.
export const isRequestAborted = (error) =>
  axios.isCancel?.(error) === true ||
  error?.code === "ERR_CANCELED" ||
  error?.name === "CanceledError" ||
  error?.name === "AbortError";

export const fetchDataAxios = async (endpoint, config = {}) => {
  try {
    const response = await api.get(`${endpoint}`, config);
    return await response;
  } catch (error) {
    if (!isRequestAborted(error)) {
      logger.error('Error fetching data:', error)
    }
    throw error;
  }
};

// export const fetchDataWithHeader = async (endpoint, userEmail) => {
//   try {
//     const api = axios.create({
//       baseURL: API_BASE_URL,
//       headers: {
//         "Content-Type": "application/json",
//         "userEmail": userEmail
//       },
//       withCredentials: true 
//     });
//     const response = await api.get(`${endpoint}`);
//     return await response;
//   } catch (error) {
//   }
// };

export const fetchDataWithHeader = async (endpoint, userEmail, config = {}) => {
  try {
    //  Use global `api` instance instead of creating a new one
    const response = await api.get(endpoint, {
      ...config,
      headers: { userEmail, ...(config.headers || {}) }, //  Add userEmail dynamically
    });

    return response;
  } catch (error) {
    if (!isRequestAborted(error)) {
      logger.error(" Error fetching data:", error)
    }
    throw error;
  }
};


export const fetchDataWithParam = async (endpoint, paramValue, config = {}) => {
  try {
    let paramValueData = paramValue ? paramValue.trim() : "";  
    // const api = axios.create({
    //   baseURL: API_BASE_URL,
    //   headers: {
    //     "Content-Type": "application/json"
    //   },
    //   withCredentials: true 
    // });
    const response = await api.get(`${endpoint}${paramValueData}`, config);
    return response;
  } catch (error) {
    if (!isRequestAborted(error)) {
      logger.error('Error fetching data:', error)
    }
    throw error;
  }
};


// export const updateApointmentData = async (endpoint, body) => {
//   let token = localStorage.getItem('user_token')
//   try {
//     const response = await fetch(`${API_BASE_URL}/${endpoint}`, {
//       method: 'PATCH',
//       headers: {
//         'Authorization': `Bearer ${token}`,
//         'Content-Type': 'application/json',
//       },
//       body: JSON.stringify(body),
//     });
//     if (!response.ok) {
//       const errorDetails = await response.json();
//       const errorMessages = Object.values(errorDetails).flat();
//       throw new Error(errorMessages[0]);
//     }
//     return await response;
//   } catch (error) {
//     throw error;
//   }
// };

export const registerAdmin = async (endpoint, body) => {
  try {
    const response = await api.post(`${endpoint}`, body);
    return response; 
  } catch (error) {
    logger.error("Registration Failed:", error.response?.data || error.message)
    throw error; 
  }
};

export const logoutUser = async () => {
  try {
    const response = await api.post(
      "/auth/logout",
      {},
      { withCredentials: true }
    );
    return response;
  } catch (error) {
    logger.error("Logout Failed:", error.response?.data || error.message)
    throw error;
  }
};
export const logoutUserRedirect = () => {
  localStorage.clear();
  window.location.href = "/login"; 
};


export const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json"
  } 
});

export const uploadFile = async (endpoint, body, config = {}) => {
  try {
    const response = await uploadFileApi.post(endpoint, body, config);
    return response;
    
  } catch (error) {
    logger.error(" Error fetching data:", error?.response?.data?.errorMessage)

    return  error?.response?.data?.errorMessage;
  }
};

export const  updateGroupData = async (endpoint, body, config = {}) => {
  try {
    const response = await uploadFileApi.put(endpoint, body, config);
    return response;
  } catch (error) {
    logger.error("Error fetching data:", error)
    return "Bad Request";
  }
};


export const uploadFileApi = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'multipart/form-data',
  }
});

export const downloadFileApi = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  }
});

export const downloadFile = async (endpoint) => {
  try {
    const token = localStorage.getItem("access_token");
    const response = await axios.get(`${API_BASE_URL}${endpoint}`, {
      responseType: 'blob',
      withCredentials: true,
      headers: {
        'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        Authorization: `Bearer ${token}`,
      }
    });
    return response;
  } catch (error) {
    logger.error("Error fetching file", error)
    throw error;
  }
};

// If you don't need content-type for GET, omit it
export const downloadAttendanceApi = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  headers: {
    // No Content-Type for GET request (or remove this entirely)
  }
});

export const downloadAttendanceFile = async (endpoint) => {
  try {
    const response = await axios.get(`${API_BASE_URL}${endpoint}`, {
      responseType: 'blob',
      headers: {
        'Accept': 'application/pdf',
        'Authorization': `Bearer ${localStorage.getItem("access_token")}`
      }
    });
    return response;
  } catch (error) {
    logger.error("Error fetching file", error.response || error)
    throw error;
  }
};


const refreshToken = async () => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/auth/refresh-token`,
      {},
      { withCredentials: true }
    );

    if (response.status === 204 || response.status === 200) {
      // Axios headers are normalized, but let us be extra safe
      const newAccessToken = response.headers["authorization"] || response.headers["Authorization"];
      if (newAccessToken) {
        localStorage.setItem("access_token", newAccessToken.replace("Bearer ", ""));
        return newAccessToken;
      } else {
        logger.warn("No new access token received during refresh (header missing).")
        logoutUserRedirect();
        return null;
      }
    } else {
      logger.warn(`Refresh Token request failed with status: ${response.status}`)
      logoutUserRedirect();
      return null;
    }
  } catch (error) {
    logger.error("Error during refresh token request:", error)
    logoutUserRedirect();
    return null;
  }
};

api.interceptors.request.use(
  async (config) => {
    const userEmail = localStorage.getItem("userEmail");
    if (userEmail) {
      config.headers.userEmail = userEmail;
    }
    if (config.url?.includes("/auth/logout")) {
      let userEmail = localStorage.getItem("userEmail");
      config.headers.userEmail = userEmail;
      return config;
    }
    const token = localStorage.getItem("access_token");
    if (token) {
      try {
        const decodedToken = jwtDecode(token);
        const isTokenExpired = decodedToken.exp * 1000 < Date.now();

        if (isTokenExpired) {
          const newToken = await refreshToken();
          if (newToken) {
            config.headers["Authorization"] = `Bearer ${newToken}`;
          } else {
            return Promise.reject("Unauthorized - Refresh failed");
          }
        } else {
          config.headers["Authorization"] = `Bearer ${token}`;
        }
      } catch (error) {
        logger.error("Error decoding token:", error)
        localStorage.removeItem("access_token"); // Token might be invalid, clear it
        // Optionally redirect to login here if you suspect a corrupted token
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    // 403 = Forbidden (user is authenticated but lacks permission).
    // Do NOT attempt a token refresh for 403 — just reject so the component
    // can show a toast or handle it gracefully. Only 401 means the token expired.
    if (error.response?.status === 403) {
      return Promise.reject(error);
    }

    if (error.response?.status === 401 && !error.config?._retry) {
      if (error.config.url.includes("/refresh-token")) {
        logoutUserRedirect();
        return Promise.reject(error);
      }

      error.config._retry = true; // Prevent infinite matching/looping
      const newToken = await refreshToken();

      if (newToken) {
        // Ensure standard Bearer formatting
        const formattedToken = newToken.startsWith("Bearer ") ? newToken : `Bearer ${newToken}`;
        error.config.headers["Authorization"] = formattedToken;
        return api(error.config); // Retry the original request
      } else {
        logoutUserRedirect();
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

uploadFileApi.interceptors.request.use(
  async (config) => {
    const { email } = getAuthContext();
    if (email) {
      config.headers.userEmail = email;
    }

    const token = localStorage.getItem("access_token");
    if (token) {
      try {
        const decodedToken = jwtDecode(token);
        const isTokenExpired = decodedToken.exp * 1000 < Date.now();

        if (isTokenExpired) {
          const newToken = await refreshToken();
          if (newToken) {
            config.headers["Authorization"] = `Bearer ${newToken}`;
          } else {
            return Promise.reject("Unauthorized - Refresh failed");
          }
        } else {
          config.headers["Authorization"] = `Bearer ${token}`;
        }
      } catch (error) {
        logger.error("Error decoding token:", error)
        localStorage.removeItem("access_token"); // Token might be invalid, clear it
        // Optionally redirect to login here if you suspect a corrupted token
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);


// Request Interceptor: Attach Access Token to Every Request
// api.interceptors.request.use(
//   async (config) => {
//     let token = localStorage.getItem("access_token");

//     if (token) {
//       const decodedToken = jwtDecode(token);
//       const isTokenExpired = decodedToken.exp * 1000 < Date.now();

//       if (isTokenExpired) {

//         token = await refreshToken();

//         if (!token) {
//           localStorage.clear();
//           logoutUserRedirect();
          
//           return Promise.reject("Unauthorized");
//         }
//       }

//       // config.headers.authorization = `${token}`;
//       config.headers["Authorization"] = `Bearer ${token}`;
//     }
//     return config;
//   },
//   (error) => Promise.reject(error)
// );

// // ✅ Response Interceptor: Handle Unauthorized Errors
// api.interceptors.response.use(
//   (response) => response,
//   async (error) => {
//     // const navigate = useNavigate(); // ✅ Use navigate inside the interceptor
//     if (error.response?.status === 401) {

//       if (error.config.url.includes("/refresh-token")) {
//         logoutUserRedirect();
//         return Promise.reject(error);
//       }

//       const newToken = await refreshToken();

//       if (newToken) {
//         error.config.headers["Authorization"] = `Bearer ${newToken}`;
//         return api.request(error.config);
//       }

//       logoutUserRedirect();
//       return Promise.reject(error);
//     }

//     return Promise.reject(error);
//   }
// );

// // Function to Refresh Token
// export const refreshToken = async () => {
//   try {
//     const response = await axios.post(
//       API_BASE_URL + "/auth/refresh-token",
//       {},
//       { withCredentials: true }
//     );

//     if (response.status === 200) {
//       const newAccessToken = response.headers["authorization"]; // Extract new token
//       if (!newAccessToken) {
//         logoutUserRedirect();
//         return null;
//       }
//       localStorage.setItem("access_token", newAccessToken);
//       return newAccessToken;
//     } else {
//       logoutUserRedirect();
//       return null;
//     }
//   } catch (error) {
//     if (error.response && error.response.status === 401) {
//       return null;  // ✅ Stop retrying refresh token
//     }
//     logoutUserRedirect();
//     return null;
//   }
// };
